import { createFileRoute } from "@tanstack/react-router";
import CheckEmail from "@/ui/components/auth/check-email";

export const Route = createFileRoute("/_auth/check-email")({
  component: CheckEmail,
});
